const BLANK_NAME_ERROR = 'District name should not be blank';

function validateName(name) {
  const errors = [];

  if (!name) {
    errors.push(BLANK_NAME_ERROR);
  }

  return errors.length ? errors : null;
}

const EXTERNALID_ERROR = 'External ID has to match CMP';

function validateExternalId(externalId) {
  const errors = [];

  const externalIdInteger = parseInt(externalId);

  if (!externalIdInteger) {
    errors.push(EXTERNALID_ERROR);
  }

  return errors.length ? errors : null;
}

export function validateDistrictForm(name, externalId) {
  const nameErrors = validateName(name);
  const externalIdErrors = validateExternalId(externalId);

  if (nameErrors || externalIdErrors) {
    return {
      name: nameErrors,
      externalId: externalIdErrors
    };
  } else {
    return null;
  }
}
